/**
 * Utility functions for converting between UI string values and database boolean values
 * for SKU source settings. This maintains backward compatibility while allowing
 * dropdown components to work with string keys.
 */

export const SKU_SOURCE_UI_VALUES = {
  SELLING_CHANNEL: 'false',
  SHIPSTATION_CATALOG: 'true',
};

/**
 * Converts a boolean database value to a string UI value for dropdown compatibility
 * @param {boolean} booleanValue - The boolean value from database/settings
 * @returns {string} String value for UI dropdown ('false' for selling channel, 'true' for ShipStation catalog)
 */
export const booleanToSkuSourceString = (booleanValue) => {
  return booleanValue ? SKU_SOURCE_UI_VALUES.SHIPSTATION_CATALOG : SKU_SOURCE_UI_VALUES.SELLING_CHANNEL;
};

/**
 * Converts a string UI value to a boolean database value
 * @param {string} stringValue - The string value from UI dropdown
 * @returns {boolean} Boolean value for database storage (true for ShipStation catalog, false for selling channel)
 */
export const skuSourceStringToBoolean = (stringValue) => {
  return stringValue === SKU_SOURCE_UI_VALUES.SHIPSTATION_CATALOG;
};
